import Vue from 'vue'
import Router from 'vue-router'
import gtagjs from 'vue-gtagjs'
import Index from '@/components/Index'
import Tickets from '@/components/Tickets'
import AGB from '@/components/Agb'
import Impressum from '@/components/Impressum'
import TooLate from '@/components/TooLate'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      redirect: '/de'
    },
    {
      path: '/de',
      name: 'de-Main',
      component: Index
    },
    {
      path: '/en',
      name: 'en-Main',
      component: Index
    },
    {
      path: '/de/info',
      name: 'de-Infos',
      component: Index
    },
    {
      path: '/en/info',
      name: 'en-Infos',
      component: Index
    },
    {
      path: '/de/termine',
      name: 'de-Termine',
      component: Index
    },
    {
      path: '/en/dates',
      name: 'en-Termine',
      component: Index
    },
    {
      path: '/de/details',
      name: 'de-Details',
      component: Index
    },
    {
      path: '/en/details',
      name: 'en-Details',
      component: Index
    },
    {
      path: '/de/tickets/',
      name: 'de-Tickets',
      component: Index
    },
    {
      path: '/en/tickets/',
      name: 'en-Tickets',
      component: Index
    },
    {
      path: '/de/tickets/:id',
      name: 'de-Ticketbuchung',
      component: Tickets,
      props: true
    },
    {
      path: '/en/tickets/:id',
      name: 'en-Ticketbuchung',
      component: Tickets,
      props: true
    },
    {
      path: '/de/agb',
      name: 'AGB',
      component: AGB
    },
    {
      path: '/de/impressum',
      name: 'de-Impressum',
      component: Impressum
    },
    {
      path: '/en/legal',
      name: 'en-Impressum',
      component: Impressum
    },
    {
      path: '/toolate',
      name: 'TooLate',
      component: TooLate
    }
  ]
});

router.afterEach(to => {
  if (to.meta.analytics === "manual") {
    gtagjs((cb) => {
      cb(to.fullPath);
    }, "UA-41500249-12", {
      gtagOpt: {
        'send_page_view': false
      }
    });
  } else {
    gtagjs((cb) => {
      cb(to.fullPath);
    }, "UA-41500249-12");
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js